import React from "react";
import ReactJWPlayer from "react-jw-player";
import { map } from "ramda";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/styles";
import { HIDE_VIEWER } from "media-viewer/mediaViewerRedux";
import AppBar from "@material-ui/core/AppBar";
import Close from "@material-ui/icons/Close";
import Dialog from "@material-ui/core/Dialog";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles(theme => ({
  title: {
    textAlign: "center",
    flex: 1,
    color: theme.palette.text.secondary,
  },
  appBar: {
    backgroundColor: "white",
    boxShadow: "none",
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    backgroundColor: "white",
    boxShadow: "none",
  },
  dialogBody: {
    borderTop: `1px solid ${theme.palette.grey[300]}`,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    backgroundColor: theme.palette.grey[100],
    flex: 1,
    position: "relative",
    overflow: "hidden",
    display: "flex",
    alignItems: "center",
  },
  playerContainer: {
    flex: 1,
    margin: 12,
  },
}));

const mapSources = map(o => ({
  file: o.url,
  label: o.resolution,
}));

const VideoViewerDialog = () => {
  const classes = useStyles();
  const { media } = useSelector(state => state.mediaViewer);
  const dispatch = useDispatch();
  const onClose = () => dispatch({ type: HIDE_VIEWER });

  return (
    <Dialog
      fullScreen={true}
      onClose={onClose}
      aria-label="video player"
      open={true}
    >
      <AppBar className={classes.appBar} position="relative">
        <Toolbar variant="dense">
          <Typography variant="h5" className={classes.title}>
            {media.title}
          </Typography>
          <IconButton edge="end" onClick={onClose} aria-label="close">
            <Close />
          </IconButton>
        </Toolbar>
      </AppBar>
      <div className={classes.dialogBody}>
        <div className={classes.playerContainer}>
          <ReactJWPlayer
            isAutoPlay={true}
            playerScript="https://cdn.jwplayer.com/libraries/nSGiuJOY.js"
            customProps={{
              sources: mapSources(media.videoFormats),
              image: media.thumbnailUrl,
            }}
          />,
        </div>
      </div>
    </Dialog>
  );
};

export default VideoViewerDialog;
